import { Pencil, Trash2 } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { RowAction } from '@nucleus-commerce/admin-kit/index-table';
import type { BlogCategory } from '@nucleus-commerce/api-client/admin';

/** Edit and delete; the page offers them only with `content.write`. */
export function useBlogCategoryRowActions({
  onEdit,
  onDelete,
}: {
  onEdit: (row: BlogCategory) => void;
  onDelete: (row: BlogCategory) => void;
}) {
  const { t } = useTranslation('blog');
  return useMemo<Array<RowAction<BlogCategory>>>(
    () => [
      { id: 'edit', label: t('actions.edit'), icon: <Pencil aria-hidden />, onAction: onEdit },
      {
        id: 'delete',
        label: t('actions.delete'),
        icon: <Trash2 aria-hidden />,
        variant: 'destructive',
        onAction: onDelete,
      },
    ],
    [onDelete, onEdit, t],
  );
}
